(function() {
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile) return;

  function isOnePieceSingleCollection(url) {
    return url.origin === window.location.origin && url.pathname.indexOf('/collections/op-') === 0;
  }

  function mobileLiteUrl(url) {
    return url.pathname + '?view=mobile-lite' + (url.hash || '');
  }

  function cleanOp15Links(root) {
    root = root || document;
    root.querySelectorAll('a[href]').forEach(function(link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (isOnePieceSingleCollection(url) && url.searchParams.get('view') !== 'mobile-lite') link.setAttribute('href', mobileLiteUrl(url));
      } catch (error) {}
    });
  }

  if (window.location.pathname.indexOf('/collections/op-') === 0) {
    var currentParams = new URLSearchParams(window.location.search);
    if (currentParams.get('view') !== 'mobile-lite') {
      window.location.replace(window.location.pathname + '?view=mobile-lite' + window.location.hash);
      return;
    }
  }

  cleanOp15Links();

  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (isOnePieceSingleCollection(url) && url.searchParams.get('view') !== 'mobile-lite') {
        event.preventDefault();
        window.location.assign(mobileLiteUrl(url));
      }
    } catch (error) {}
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanOp15Links);
  } else {
    setTimeout(cleanOp15Links, 0);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) cleanOp15Links(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
